import { render, staticRenderFns } from "./update-group-info.html?vue&type=template&id=087d5b72&scoped=true&external"
import script from "./update-group-info.js?vue&type=script&lang=js&external"
export * from "./update-group-info.js?vue&type=script&lang=js&external"
import style0 from "./update-group-info.scss?vue&type=style&index=0&id=087d5b72&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d5b72",
  null
  
)

export default component.exports